export const initNewWindow = () => {
  const buttonLink = document.querySelectorAll('.button a');

  if (!buttonLink) {
    return;
  }

  for (let i = 0; i < buttonLink.length; i++) {
    if (buttonLink[i].href.includes('.pdf')) {
      buttonLink[i].setAttribute('target', '_blank');
    }
  }
};
